import React, {useState} from 'react';
import Strings from "../Lang/strings";

const Input = ({name, value, title, placeholder, handleChange, type, required = true}) => {
    const onInputChange = (e) => {
        if (type === "number") {
            if (e.target.value <= 0) {
                e.target.value = null;
            }
        }
        handleChange(e);
    }
    return (
        <>
            <label className="block text-gray-700 capitalize mb-1" htmlFor={name}>
                {Strings.getString(title)}
                {
                    required
                        ? <small className={`text-red-600 font-300 capitalize  text-xs`}>
                            <code> *</code>
                            {Strings.required}
                        </small>
                        : <small className={`text-green-600 font-300 capitalize text-xs`}>
                            <code> *</code>
                            {Strings.optional}
                        </small>
                }

            </label>
            <input
                min="0"
                value={value}
                autoComplete={name}
                onChange={onInputChange}
                className="talabatey-outline   border rounded w-full py-2 px-3 text-grey-darker"
                name={name}
                id={name}
                maxLength="55"
                type={type}
                placeholder={Strings.getString(placeholder)}/>
        </>
    );
}
export default Input;
